
import { Component, Vue } from 'vue-property-decorator'
import keyCodeMapperCharacter from '@/utils/keycodemap.utils'
import * as onScan from 'onscan.js'
import StockMappingProvider from '@/resources/stock-mapping.provider'

@Component({
  components: {}
})
export default class StockMappingLocation extends Vue {
  stockMappingService = new StockMappingProvider()

  location: any = null

  loadingLocation = false

  loadingProduct = false

  page = 1

  totalPages = 0

  totalItems = 0

  items: any = []

  isFirstFetch = true

  mounted (): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this
    onScan.attachTo(document, {
      suffixKeyCodes: [13],
      reactToPaste: true,
      onScan (sCode) {
        const patternUrl = /^(https:\/\/www\.gentlewomanonline\.com\/|https:\/\/gentlewomanonline\.com\/|https:\/\/www\.matter-makers\.com\/|https:\/\/matter-makers\.com\/)/
        const patternOldLocation = /^location::/
        const scanned = sCode.trim()
        if (patternOldLocation.test(scanned)) {
          _this.$buefy.toast.open({ message: 'QR Location แบบเก่าใช้กับ WMS ไม่ได้', type: 'is-danger' })
        } else if (patternUrl.test(scanned.toLowerCase()) || !scanned) {
          _this.$buefy.toast.open({ message: 'กรุณาสแกน QR Code ของ Location', type: 'is-danger' })
        } else {
          // QR ของ location คือชื่อ location
          _this.getLocation(scanned)
        }
      },
      keyCodeMapper (oEvent: any) {
        // onScan ตัด space ทิ้ง แต่ชื่อ location มีช่องว่างได้
        if (+oEvent.keyCode === 32) return ' '
        if (keyCodeMapperCharacter[+oEvent.keyCode] !== undefined) {
          return keyCodeMapperCharacter[+oEvent.keyCode][+oEvent.shiftKey]
        }
        return onScan.decodeKeyEvent(oEvent)
      }
    })
  }

  onScroll (): void {
    if (this.loadingProduct) return
    if (this.page >= this.totalPages) return

    const el = this.$refs.scrollWrapper as HTMLElement
    if (!el) return

    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 120

    if (nearBottom) {
      this.page++
      this.fetchPaginate()
    }
  }

  // แยกการ์ดตาม store ด้วย เพราะ API คืนรายการของทุก store
  get groupedProducts (): Array<any> {
    const map: any = {}

    this.items.forEach((item: any) => {
      const storeId = item.store?.id ?? ''
      const key = `${storeId}::${item.product?.id ?? item.code}`

      if (!map[key]) {
        map[key] = {
          key,
          name: item.product?.name ?? item.name ?? '',
          code: item.code?.replace(/\.\d+$/, '') ?? '',
          image: item.product?.photoUrls?.[0] ?? '',
          storeName: item.store?.name ?? '',
          skus: []
        }
      }

      map[key].skus.push({
        id: item.id,
        code: item.code ?? '',
        colorSize: `${item.sku?.color?.name?.toUpperCase() ?? ''} - ${item.sku?.size?.name?.toUpperCase() ?? ''}`,
        qty: item.qty ?? 0
      })
    })

    return Object.values(map)
  }

  async getLocation (name: string): Promise<void> {
    this.isFirstFetch = true
    try {
      this.loadingLocation = true
      const { data } = await this.stockMappingService.getLocationByName(name)
      if (data) {
        this.location = data
        this.fetchPaginate(true)
      } else {
        this.$buefy.toast.open({ message: `ไม่พบ location: ${name}`, type: 'is-danger' })
      }
    } catch (error: any) {
      const message = error?.code === 404
        ? `ไม่พบ location: ${name}`
        : 'เกิดข้อผิดพลาดในการดึงข้อมูล location'
      this.$buefy.toast.open({ message, type: 'is-danger' })
    } finally {
      this.loadingLocation = false
    }
  }

  // eslint-disable-next-line class-methods-use-this
  defaultEmptyObject (obj: any, key: string, defaultValue: string): string {
    return obj && obj[key] ? obj[key] : defaultValue
  }

  async fetchPaginate (isClear = false): Promise<any> {
    if (isClear) {
      this.page = 1
      this.totalPages = 0
      this.totalItems = 0
      this.items = []
    }

    // สแกน location ใหม่ระหว่างโหลด: ทิ้งผลของ location เก่า
    const locationId = this.location.id
    try {
      this.loadingProduct = true
      const { data } = await this.stockMappingService.getMappingByLocation({
        location: locationId,
        page: this.page,
        limit: 20
      })
      if (this.location?.id !== locationId) return
      if (data.results?.length) {
        this.items = [
          ...this.items,
          ...data.results
        ]
      }
      this.totalPages = data.pages
      this.totalItems = data.total
    } catch (error: any) {
      this.$store.dispatch('Components/setSnackbar', {
        value: true,
        message: error?.message || error,
        type: 'error'
      })
    } finally {
      if (this.location?.id === locationId) {
        this.loadingProduct = false
        this.isFirstFetch = false
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  beforeDestroy (): void {
    onScan.detachFrom(document)
  }
}
